import { transparentize } from 'polished';

import flights from './theme/options.booking.flights';
import common from './theme/colors.common';
import flightsColors from './theme/colors.booking.flights';
import bookingTravelers from './theme/colors.booking.travelers';
import ancillariesColors from './theme/colors.booking.ancillaries';
import carsColors from './theme/colors.boneyard.cars';
import confirmationColors from './theme/colors.booking.confirmation';
import hotelsColors from './theme/colors.booking.hotels';
import * as boneyardColors from './theme/colors.boneyard';

import {
  white,
  brownishGrey,
  gradientOrange,
  waterBlue,
  peacockBlue,
  tangerine,
  lightGrey,
  sunflowerYellow,
  sunflowerYellowGradient,
  grey100,
  greyA100,
  grey900,
  dark,
  blue700,
  blue100,
  lightBlue900,
  lightBlueGrey,
  red500,
  paleGrey,
  blueGrey,
  darkGrey,
  yellow800,
  lightBackgroundBlue,
  black,
  lightBlue200,
  paleRed,
} from './theme/colors';

const section = {
  divider: {
    background: sunflowerYellow,
  },
};

const bookingBackground = {
  background: greyA100,
};

const alertBar = {
  expired: paleRed,
  success: '#e3f9dc',
  info: '#fff6cc',
};

const siteHeader = {
  text: white,
  background: {
    from: waterBlue,
    to: peacockBlue,
  },
  stadiumBackground: {
    from: '#4a4a4a',
    to: black,
  },
  light: {
    linkColor: peacockBlue,
    linkBackground: white,
  },
  dark: {
    linkColor: white,
    linkBackground: peacockBlue,
  },
  linkActive: tangerine,
  silver: '#c0c0c0',
};

const siteLayout = {
  background: {
    default: lightBlue200,
    sm: '#fff',
  },
};

const siteFooter = {
  background: greyA100,
  title: peacockBlue,
  link: grey900,
  divider: grey100,
};

const bundle = {
  text: '#01579b',
  outerBorder: '#f4f5f6',
  borderBelowPageHeading: '#cfd8dc',
  innerGridBorder: '#d8d8d8',
  mobileDisabledAncillary: '#C2D6E7',
  percentageText: '#263238',
  tier_4: {
    label: '#1D2740',
    labelText: '#FFFFFF',
    selectedBackground: '#e8e8e8',
  },
  tier_3: {
    label: '#4d4d4f',
    labelText: '#bbbdbe',
    selectedBackground: '#e8e8e8',
  },
  tier_2: {
    label: '#01579b',
    labelText: '#ccd5e8',
    selectedBackground: '#dee9f2',
  },
  tier_1: {
    label: '#bbdefb',
    labelText: '#5e5e5e',
    selectedBackground: '#f1f9fe',
  },

  mobileNotSelectedBackground: 'linear-gradient(to bottom, #fdfdfd, #fbfbfb)',
};

const breadcrumb = {
  active: {
    text: common.textSecondary,
    border: tangerine,
    background: greyA100,
  },
  link: {
    text: common.textSecondary,
    border: peacockBlue,
    compact: peacockBlue,
  },
  inactive: {
    text: lightGrey,
    border: lightGrey,
  },
  compactView: {
    text: peacockBlue,
    activeSegment: peacockBlue,
    inactiveSegment: grey100,
  },
};

const pageHeading = {
  title: peacockBlue,
};

const disclaimer = {
  linkText: waterBlue,
  buttonText: waterBlue,
  text: common.textSeconday,
  externalLinkIcon: waterBlue,
};

const popup = {
  icon: waterBlue,
  title: waterBlue,
  text: peacockBlue,
};

const seatsPage = {
  leftColumn: paleGrey,
  sideFooter: {
    boxShadow: '#c0cad4',
    background: greyA100,
    border: grey100,
    darkBlack: black,
  },
  tabs: {
    default: paleGrey,
    defaultText: peacockBlue,
    defaultBorder: lightBlueGrey,
    active: peacockBlue,
    activeText: white,
    activeBorder: 'transparent',
  },
  aircraftMap: {
    text: brownishGrey,
    border: blueGrey,
    background: paleGrey,
  },
  aircraftTitle: {
    text: peacockBlue,
  },
  actionContinueButton: {
    defaultText: peacockBlue,
  },
  travelerList: {
    label: white,
    labelOutline: sunflowerYellow,
  },
  badge: {
    text: white,
    background: peacockBlue,
    activeText: peacockBlue,
    activeBackground: 'linear-gradient(315deg, #ffb100, #ffd200 1%)',
  },
  lightBlueBackgroundSeat: lightBlue200,
  seatLegendColor: '#585759',
  autoSelectGrey: '#ececec',
  grey900: grey900,
  backgroundColorSM: '#fff',
  economyTextBlackColor: black,
  newFareClassText: '#FFFFFF',
  windowlessSeat : {
    scrollBoxShadow:  'rgba(0, 0, 0, 0.5)',
    scrollBoxBorder: '#cfd8dc',
    text: grey900,
    background: peacockBlue,
    yellowBackground: '#fff9d9',
  }
};

const seatMap = {
  front: brownishGrey,
  seat: {
    unavailable: lightBlueGrey,
    taken: peacockBlue,
    text: white,
    legroom: waterBlue,
    allegiantExtra: peacockBlue,
    economyText: darkGrey,
    economy: blue100,
    takenGradientStart: sunflowerYellow,
    takenGradientEnd: gradientOrange,
    rowNumber: brownishGrey,
    allegiantExtraSeat: '#f5a81f',
    legroomSeat: peacockBlue,
    economySeat: '#a3c1db',
    unavailableSeat: '#58585a',
    allegiantExtraGradOne: '#fece06',
    allegiantExtraGradTwo: '#f6ab1e',
    border: grey100,
    yellowBackground: '#fff9d9',
    fareClassSeat: '#1F273E',
    newFareClassSeat: '#182245',
    newFareClassBorder: '#0E1F2C',
    expandoDisabledBackground: '#C7C7C7',
    expandoDisabledText: '#626F79',
  },
  block: {
    label: dark,
  },
  popover: {
    travelerName: dark,
    seatInfo: dark,
    text: peacockBlue,
    background: white,
    outline: peacockBlue,
  },
  windowlessSeat: {
    text: grey900,
    background: peacockBlue,
    yellowBackground: '#fff9d9',
    scrollBoxBorder: '#cfd8dc',
    scrolBoxShadow: 'rgba(0, 0, 0, 0.5)',
  },
  badge: {
    text: peacockBlue,
    background: 'linear-gradient(315deg, #ffb100, #ffd200 1%)',
  },
};

const seatMapLegend = {
  title: {
    divider: '#d8d8d8',
  },
  takenIndexGradientStart: sunflowerYellow,
  takenIndexGradientEnd: gradientOrange,
  unavailableIcon: lightBlueGrey,
  exitIcon: lightBlueGrey,
  allegiantExtraIcon: peacockBlue,
  allegiantExtraIconText: white,
  legroomPlusIcon: waterBlue,
  legroomPlusIconText: white,
  economyIcon: blue100,
  economyIconText: '#4d4d4f',
  text: brownishGrey,
  economyBlueExpando: '#013057',
  darkGreySeat: '#111',
  accordionBorder: '#979797',
  tabLegend: '#333',
  tabContainer: '#ccc',
  newFareClassText: '#FFFFFF',
};

const datePicker = {
  highlight: sunflowerYellowGradient,
  background: {
    from: 'rgb(230, 233, 236)',
    to: white,
  },
  icons: {
    disabled: brownishGrey,
    active: peacockBlue,
    activeBackground: {
      from: '#FFD200',
      to: '#FFB100',
    },
  },
};

const fieldPlaceholderInfoText = {
  icon: {
    text: peacockBlue,
    background: white,
  },
  text: white,
};

const flightSearchForm = {
  textColor: white,
  background: {
    from: transparentize(0.15, waterBlue),
    to: peacockBlue,
  },
  travelersExpandoLabels: peacockBlue,
};

const popover = {
  background: peacockBlue,
  text: white,
  iconClose: white,
};

const select = {
  label: white,
  groupDivider: lightGrey,
  optionText: peacockBlue,
  disabledText: brownishGrey,
  disabledBackground: white,
  placeholderText: brownishGrey,
  error: red500,
};

const hotelOnMap = {
  address: '#716f6f',
};

const spinner = {
  light: white,
  dark: peacockBlue,
};

const bagsAncillaryShop = {
  text: dark,
  groupDivider: '#cfd8dc',
  backgroundColor: 'rgba(113, 111, 111, 0.05)',
  prioirtyAccess: {
    text: peacockBlue,
    darkBlue: '#015699',
    priceColor: '#fbfbfb',
  },
};

const focusStyle = `
  outline: none;
  box-shadow: 0 0 0 2px ${sunflowerYellow};
`;

const focusStyleInverted = `
  box-shadow: 0 0 0 1px ${peacockBlue};
`;

const cart = {
  primaryBackground: '#eaf2f9',
  secondaryBackground: white,
  payAtHotelBackground: peacockBlue,
  payAtHotelText: white,
  text: dark,
  item: {
    background: greyA100,
    border: '#d8d8d8',
    edit: peacockBlue,
    highlightBackground: 'rgba(45, 153, 9, 0.15)',
  },
  priceBreakdown: {
    item: {
      border: grey100,
    },
    infoPopover: {
      background: peacockBlue,
    },
  },
  promo: 'rgba(45, 153, 9, 0.15)',
  upliftText: blue700,
  footerBorder: '#d8d8d8',
  travelerSeparator: '#d8d8d8',
  travelerItem: lightBlue900,
};
const payment = {
  border: '#cfd8dc',
  sectionFooter: 'rgba(45, 153, 9, 0.15)',
  outerBorder: '#e7ebed',
  separator: '#d8d8d8',
  totalPaymentBackground: '#f4f5f6',
  tripSummaryBackground: '#e9f1f9',
  instantCreditHeader: lightBlue900,
  instantCreditBackground: lightBackgroundBlue,
  instantCreditDivider: yellow800,
  instantCreditText: grey900,
  instantCreditBannerGrey: greyA100,
};

const vehicles = {
  border: '#cfd8dc',
};

/*
The z-indexes in the theme are the z-indexes for components whose stacking context
is the root stacking context. The components that are in a different stacking context
should have their z index defined in relation to that context, otherwise layering
issues might appear. For more details on z index and stacking contexts :
https://www.oreilly.com/library/view/developing-web-components/9781491905685/ch04.html and
https://philipwalton.com/articles/what-no-one-told-you-about-z-index/
For checking what stacking context a component is in you can use the Chrome extension z-context:
https://chrome.google.com/webstore/detail/z-context/jigamimbjojkdgnlldajknogfgncplbh
*/

const zIndex = {
  negative: -1,
  breadcrumbNav: {
    container: 1,
    containerArrow: 2,
  },
  spinnerOverlay: 99,
  siteHeader: 200,
};

const theme = {
  colors: {
    ...boneyardColors,
    greyA100,
    common,
    disclaimer,
    pageHeading,
    breadcrumb,
    bundle,
    travelers: bookingTravelers,
    flights: flightsColors,
    confirmation: confirmationColors,
    popup,
    seatsPage,
    seatMap,
    seatMapLegend,
    siteHeader,
    siteLayout,
    siteFooter,
    datePicker,
    fieldPlaceholderInfoText,
    flightSearchForm,
    popover,
    select,
    spinner,
    cart,
    section,
    payment,
    bagsAncillaryShop,
    hotelOnMap,
    vehicles,
    bookingBackground,
    alertBar,
  },
  layout: {
    headerBarHeight: 50,
    headerBarHeightMd: 70,
    headerBarHeightImpersonation: 110,
  },
  zIndex,
  focusStyle,
  focusStyleInverted,
  flights,
  ancillariesColors,
  carsColors,
  hotelsColors,
};

export default theme;
